import { Axios } from 'src/utils';

export const getAllDepartments = async () => {
  try {
    const response = await Axios.get(`/admin/departments`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getManagedDepartments = async () => {
  try {
    const response = await Axios.get(`/departments`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getManagedAdminDepartment = async () => {
  try {
    const response = await Axios.get(`/super-admin/departments`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const departmentDetail = async (id) => {
  try {
    const response = await Axios.get(`/admin/departments/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addNewDepartment = async (body) => {
  try {
    const response = await Axios.post(`/admin/departments`, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDepartment = async (id, body) => {
  try {
    const response = await Axios.put(`/admin/departments/${id}`, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};
